import { Scissors } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth';
import { ErrorBox, Spinner } from '../components/base';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [signingIn, setSigningIn] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSigningIn(true);
    try {
      await signIn(email, password);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not sign in.');
    } finally {
      setSigningIn(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper-100 px-4 dark:bg-ink-900">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 rounded-xl bg-brand-500 p-3 text-white">
            <Scissors className="h-7 w-7" aria-hidden />
          </div>
          <h1 className="text-xl font-semibold">Snip.work App</h1>
          <p className="mt-1 text-sm text-ink-500 dark:text-ink-400">
            Sign in to see your products
          </p>
        </div>

        <form onSubmit={submit} className="card space-y-4 p-6">
          {error && <ErrorBox message={error} />}

          <div>
            <label htmlFor="email" className="form-label">Email</label>
            <input
              id="email" type="email" className="field" value={email} required
              autoComplete="username" autoFocus
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@company.com"
            />
          </div>

          <div>
            <label htmlFor="password" className="form-label">Password</label>
            <input
              id="password" type="password" className="field" value={password} required
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-primary w-full justify-center" disabled={signingIn}>
            {signingIn && <Spinner className="h-4 w-4" />}
            {signingIn ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-ink-400">
          snip.work · beta
        </p>
      </div>
    </div>
  );
}
